/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const authorAlbumCollectionModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"nickname": z.string().describe("Псевдоним"),
"avatar": z.lazy(() => fileModelSchema).describe("Аватар").nullable().nullish(),
"contactInfo": z.string().describe("Контактная информация").nullable().nullish(),
"description": z.string().describe("Описание").nullable().nullish(),
"isCoauthor": z.boolean().describe("Является ли соавтором")
    })